export enum AccessGroupUserType {
  Permanent = 'Permanent',
  TimeLimited = 'TimeLimited',
}
